export default __webpack_public_path__ + "static/media/img (2).8096ef83.jpg";